import React from "react";

const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block" }}
    {...props}
  >
    <line
      x1="18"
      y1="8"
      x2="18"
      y2="20"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <polyline
      points="13,16 18,21 23,16"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="6" y="26" width="24" height="3" rx="1.5" fill="currentColor" />
    <rect x="6" y="22" width="3" height="7" rx="1.5" fill="currentColor" />
    <rect x="27" y="22" width="3" height="7" rx="1.5" fill="currentColor" />
  </svg>
);

export default DownloadIcon;